import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { Link } from "react-router-dom"

import { getIcon } from "utils/icon"
import { useTranslation } from "providers/i18n"
import { Head } from "components/Head"
import { EmptyData } from "components/EmptyData"
import { PercentIcon } from "components/icons"
import { PageLayout } from "extensions/iconsiam/layouts/PageLayout"
import { Header } from "extensions/iconsiam/components/Header"
import { usePromotion } from "extensions/iconsiam/hooks/promotion"
import { VenueFilterBar } from "extensions/iconsiam/components/VenueFilterBar"
import { PromotionCard } from "extensions/iconsiam/components/domains/promotions"
import { HeaderSearchButton } from "extensions/iconsiam/components/Header/HeaderSearchButton"

export const Promotions = ({ Layout = PageLayout }) => {
  const { t } = useTranslation()
  const { changeVenueFilter, venueFilter, promotions } = usePromotion()
  const theme = useTheme()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.promotions) || <PercentIcon />,
    [theme]
  )

  const { styleOverrides } = theme.components?.[`PromotionPage`] || {}
  const { root, gridContainer, emptyDataWrapper } = styleOverrides

  return (
    <>
      <Head title={t("Promotions")} />
      <Layout
        header={
          <Header
            filterBar={
              <VenueFilterBar
                onClickVenue={changeVenueFilter}
                value={venueFilter}
              />
            }
            searchButton={<HeaderSearchButton />}
          />
        }
      >
        <Box sx={root}>
          {promotions && promotions.length > 0 ? (
            <Box sx={gridContainer}>
              {promotions.map((promotion) => {
                const sponsoredId = promotion?.properties?.sponsoredId
                return (
                  <Link
                    to={`/promotions/${promotion.id}`}
                    key={`${sponsoredId || ""}${promotion.id}`}
                  >
                    <PromotionCard promotion={promotion} />
                  </Link>
                )
              })}
            </Box>
          ) : (
            <Box sx={emptyDataWrapper}>
              <EmptyData
                icon={emptyIcon}
                primary={t(`Coming Soon`)}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </Box>
      </Layout>
    </>
  )
}
